import React, { useEffect, useState } from "react";
import { Colors } from "../../Constants/colors";
import PaginationArrow from "../../images/pagination-arrow.svg";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  totalPage: number;
  onPageChange: (pageNo: number) => unknown;
}
enum PAGE_ACTION_TYPE {
  NEXT = "NEXT",
  PREV = "PREV",
}

export const Pagination = ({ totalPage, onPageChange }: Props) => {
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [pageNumbers, setPageNumbers] = useState<Array<number>>([]);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const page = parseInt(searchParams.get("page") || "") || 1;

  useEffect(() => {
    if (page > totalPage) {
      return changePageInNavigate(1);
    }

    setSelectedPage(page);
    const totalPageNumber = totalPage ? (totalPage > 1 ? 2 : 1) : 2;

    if (page % totalPageNumber === 0) {
      const pages = Array.from(
        { length: totalPageNumber },
        (_, index) => page - index
      ).sort();

      setPageNumbers(pages);
    } else if (page % totalPageNumber !== 0) {
      const pages = Array.from(
        { length: totalPageNumber },
        (_, index) => page + index
      ).sort();

      setPageNumbers(pages);
    }
  }, [page, totalPage]);

  useEffect(() => {
    onPageChange(page);
  }, [page]);

  const changePageInNavigate = (page: number) => {
    const updatedSearchParams = new URLSearchParams();
    searchParams.forEach((value, key) => {
      if (key !== "page") {
        // TODO :- Make this a utility function
        updatedSearchParams.append(key, value);
      }
    });

    updatedSearchParams.set("page", `${page}`);

    const newSearchParamsString = updatedSearchParams.toString();

    const newUrl = `${location.pathname}${
      newSearchParamsString ? "?" + newSearchParamsString : ""
    }`;

    navigate(newUrl);
  };

  const handlePageChange = ({
    type,
    index,
  }: {
    type?: PAGE_ACTION_TYPE | null;
    index: number;
  }) => {
    let pageNo = index;

    switch (type) {
      case PAGE_ACTION_TYPE.NEXT:
        if (selectedPage === totalPage) {
          pageNo = totalPage;
        } else {
          pageNo = selectedPage + 1;
        }
        break;
      case PAGE_ACTION_TYPE.PREV:
        if (selectedPage === 1) {
          pageNo = 1;
        } else {
          pageNo = selectedPage - 1;
        }
        break;
      default:
        pageNo = index;
    }
    changePageInNavigate(pageNo);
    onPageChange(pageNo);
  };

  return (
    <div className="flex justify-center items-center mt-8">
      <div className="flex w-64 h-14 p-5 justify-center items-center gap-x-2">
        <div
          className="rotate-180"
          style={{ width: "14px", height: "14px", cursor: "pointer" }}
          onClick={() => {
            handlePageChange({
              type: PAGE_ACTION_TYPE.PREV,
              index: selectedPage - 1,
            });
          }}
        >
          <img src={PaginationArrow} alt="next-icon" />
        </div>
        <div className="flex justify-center items-center px-4 gap-x-2">
          {pageNumbers.map((value, index) => {
            const isSelectedIndex = value === selectedPage;
            return (
              <div
                className="w-9 h-9 flex justify-center items-center rounded-md"
                style={{
                  backgroundColor: isSelectedIndex
                    ? Colors.TangerineOrange
                    : "",
                  color: isSelectedIndex ? Colors.White : Colors.DarkGrey,
                  cursor: "pointer",
                  boxShadow: isSelectedIndex
                    ? "rgba(0, 0, 0, 0.24) 0px 3px 8px"
                    : "",
                  textAlign: "center",
                }}
                onClick={() => {
                  handlePageChange({ index: value });
                }}
                key={index}
              >
                {value}
              </div>
            );
          })}
        </div>

        <div
          style={{ width: "14px", height: "14px", cursor: "pointer" }}
          onClick={() => {
            handlePageChange({
              type: PAGE_ACTION_TYPE.NEXT,
              index: selectedPage + 1,
            });
          }}
        >
          <img src={PaginationArrow} alt="next-icon" />
        </div>
      </div>
    </div>
  );
};
